export default "__VITE_ASSET__680d9f55__"